<template>
    <div>
        <v-app-bar
            :color="color"
            :dark="theme === 'dark'"
            :light="theme === 'light'"
            app
            :dense="dense"
        >
            <h1 class="text-h6 font-weight-black text-uppercase">
                <v-icon v-if="icon" left>{{ icon }}</v-icon>
                {{ title }}
                <slot name="subtitle"></slot>
                <v-progress-linear
                    v-if="loading"
                    indeterminate
                    size="24"
                    :color="color + ' lighten-3'"
                ></v-progress-linear>
            </h1>
            <v-spacer></v-spacer>
            <!-- Attach elements on the right side of the toolbar -->
            <slot name="buttons"></slot>
            <!-- Sends the user to the previous page -->
            <v-btn v-if="lastPage" icon @click="$router.go(-1)">
                <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <!-- Reloads the page -->
            <v-btn v-if="reloadPage" icon @click="$router.go(0)">
                <v-icon>mdi-reload</v-icon>
            </v-btn>
        </v-app-bar>
        <!-- Attach elements directly below the toolbar -->
        <div>
            <slot name="extension"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DynamicToolbar',
    props: {
        loading: Boolean,
        icon: String,
        title: String,
        color: String,
        theme: String, // light or dark
        dense: {
            type: Boolean,
            default: true
        },
        lastPage: Boolean,
        reloadPage: Boolean
    }
};
</script>
